import {
  isRejectedWithValue,
  Middleware,
  PayloadAction,
} from '@reduxjs/toolkit'
import { ServiceError } from '../../../typings'
import { HANDLED_ERROR_CODES } from '../../utils/errors/errorLookup'
import { setHandledError } from '../slices/handledErrorSlice'

interface ErrorPayload {
  payload: {
    status: number
    data: {
      message?: string
      name?: string
    }
  }
}

const getStatusCode = (statusCode: number): string => {
  if (statusCode === 401 || statusCode === 403) {
    return HANDLED_ERROR_CODES.AUTH_REQUIRED
  }

  if (statusCode === 429) {
    return HANDLED_ERROR_CODES.RATE_LIMIT_REACHED
  }

  return undefined
}

export const errorHandlerMiddleware: Middleware =
  (api) => (next) => (action: PayloadAction & ErrorPayload) => {
    const code = getStatusCode(action.payload?.status)

    if (code && isRejectedWithValue(action)) {
      const serviceErrorObject: ServiceError = {
        statusCode: action.payload.status,
        code,
        message: action.payload.data?.message || '',
        name: action.payload.data?.name || 'UNKNOWN_REJECTION',
        type: 'api',
      }

      // Call the thunk to get the actual action
      const thunkAction = setHandledError({
        data: {
          error: serviceErrorObject,
        },
      })

      // Dispatch the result of calling the thunk
      const thunkActionResult = thunkAction(api.dispatch)

      return next(thunkActionResult)
    }

    return next(action)
  }
